
<template>
    <div :class="{'bg-gray-300': folder.info.id == documentsStore.getCurrentlySelectedFolderId}" class="flex justify-between items-center movable cursor-move bg-gray-200">
        <div class="px-3 py-4 cursor-pointer flex justify-start items-center" v-on:click.stop="handleFolderClick">
            <i class="text-gray-500 fas fa-folder" style="font-size: 20px;"></i>
            <span class="ml-8">{{ folder.info.name }}</span>
        </div>
        <div class="px-3 py-4 flex justify-end" v-if="documentsStore.canInteractWithTable">
            <div class="flex space-x-3">
                <a v-on:click.stop="renameFolder"
                    class="font-medium text-rose-800 hover:text-rose-700 cursor-pointer">
                    Rename
                </a>
                <a v-on:click.stop="deleteFolder"
                    class="font-medium text-rose-800 hover:text-rose-700 cursor-pointer">
                    Delete
                </a>
            </div>
        </div>
    </div>
    <div v-if="isExpanded">
        <file-system-sortable-table 
            :folder="documentsStore.getFolder(folder.info.id)"
            :show-root="false"
            class="w-full"
        />
    </div>
    <FolderRenameModal :open="renameInitiated" :folder="folder" @close="renameInitiated = false" />
</template>
<script>

import { mapStores } from 'pinia';
import { useDocumentsStore } from '../../stores/documentsStore';
import FolderRenameModal from './FolderRenameModal.vue';

export default{
    name: "document-row",
    props: {
        folder: {
            type: Object,
            required: true
        },
        isDragging: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    components: {
        FolderRenameModal
    },
    watch: {
        isDragging(){
            if(this.isDragging){
                this.isExpanded = false;
            }
        }
    },
    computed: {
        ...mapStores(useDocumentsStore, ['folders'])
    },
    data(){
        return {
            isExpanded: false,
            renameInitiated: false,
        }
    },
    methods: {
        async deleteFolder(){
            await this.documentsStore.destroyFolder(this.folder.info.id);
        },
        async renameFolder(){
            this.renameInitiated = true;
        },
        handleFolderClick(){
            this.documentsStore.setCurrentlySelectedFolderId(this.folder.info.id);
            this.isExpanded = !this.isExpanded;
        },
    },
}

</script>

<style scoped>
  
.movable:hover {
  cursor: grab;
}

.movable:active {
  cursor: grabbing;
}
</style>